import {Fragment} from 'react'
import Avatar from '@mui/material/Avatar'
import Typography from '@mui/material/Typography'

import {fullName, firstLetterUpperCased} from '../../lib/tools'

const Greetings = props => (
  <Fragment>
    <Avatar sx={{bgcolor: 'secondary.main', width: 56, height: 56}}>{firstLetterUpperCased(props.currentUser?.firstName)}</Avatar>
    <Typography variant='h6'>{fullName(props.currentUser)}</Typography>
    <Typography variant='body1'>{props.email.address}</Typography>
  </Fragment>
)

export default Greetings
